/**
 * Created by Terence on 2022/8/23 - 17:24
 * Description :
 */
/* eslint-disable */
import {
  shouldRefreshToken,
  getRefreshToken,
  getStorageToken,
  setRefreshToken,
  setStorageToken,
  setExpireTimestamp,
  removeRefreshToken,
  removeStorageToken,
  setCookieToken,
} from "@/utils/authorize";
// @ts-ignore
import { decodeEchoOSSUrlInterceptor } from "@frontend/eros/dist/web";
import _axios from "axios";
import { showFailToast } from "vant";
import HOSTS from "@/http/hosts";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import jb from "@frontend/effuse";
import { isLinjieApp } from "@/utils/env-related";

let refreshPromise: any = null;
const RefreshTokenAxios = createRefreshTokenAxios();

const allowAclList = ["/signin/action/send-verify-code", "/signin/login/phone"];
const checkNeedDeny = (response: any) => {
  if (
    allowAclList.includes(response.config.url) ||
    /^\/posts\/.*\/comments$/.test(response.config.url)
  ) {
    return false;
  }
  return true;
};

export const commonResponseInterceptor = (response: any, promise: any) => {
  console.log("response=------", response);
  // 2xx 范围内的状态码都会触发该函数。
  // 对响应数据做点什么
  if (response.data.code === -10000) {
    setTimeout(() => {
      // 暂时移除未实名的跳转, 放开待产品通知
      // window.location.href = `${location.origin}/real-name-auth`;
    }, 300);
    return response.data;
  }

  response.data = decodeEchoOSSUrlInterceptor(response.data);

  if (response.data.code != 0 && checkNeedDeny(response)) {
    console.log("errorMsg", response?.data?.message);
    showFailToast(`${response?.data?.message}`);
  }
  if (allowAclList.includes(response.config.url)) {
    return response;
  }
  return response.data;
};

export const commonRequestInterceptor = async (
  request: any,
  headers = {},
  config: any = { ignoreRefresh: false }
) => {
  if (shouldRefreshToken() && !config.ignoreRefresh) {
    if (refreshPromise) {
      try {
        await refreshPromise;
      } catch (e) {
        console.log("refreshTokenError_skip", e);
      }
    } else {
      const refreshToken = getRefreshToken();
      const accessToken = getStorageToken();

      if (refreshToken && accessToken) {
        refreshPromise = refreshLogin({
          refreshToken,
          accessToken,
        });

        try {
          await refreshPromise;

          refreshPromise = null;
        } catch (e) {
          console.log("refreshTokenError", e);
        }
      }
    }
  }
  let token = "";

  if (isLinjieApp()) {
    console.log("try to get flutter token!!==");
    token = jb.tokenSync("") || "";
    console.log('window.dsBridge===', window.dsBridge);
    console.log('window.WebViewJSBridge===', window.WebViewJSBridge);
    console.log("flutter token", token);
  } else {
    token = getStorageToken() || "";
  }

  // 只要浏览过站点任何页面, 就会shouldRefresh
  if (token) {
    request.headers.Authorization = `Bearer ${token}`;
  }

  request.headers = {
    ...request.headers,
    ...headers,
  };

  request.headers["x-request-package-id"] = 1045;

  return request;
};

export function createRefreshTokenAxios() {
  const tempConfig = {
    baseURL: HOSTS.api,
    showError: true,
  };
  const RefreshTokenAxios = _axios.create(tempConfig);

  RefreshTokenAxios.interceptors.request.use((request) =>
    commonRequestInterceptor(request, {}, { ignoreRefresh: true })
  );

  RefreshTokenAxios.interceptors.response.use((response) => {
    return response.data;
  });

  return RefreshTokenAxios;
}

function refreshLogin({
  refreshToken,
  accessToken,
}: {
  refreshToken: string;
  accessToken: string;
}) {
  return RefreshTokenAxios.post("/signin/login/refresh", {
    refreshToken,
    accessToken,
  })
    .then(({ data }) => {
      setRefreshToken(data.refreshToken);
      setStorageToken(data.accessToken);
      setExpireTimestamp(data.expiresIn * 1000);
      setCookieToken(data.accessToken);
    })
    .catch(() => {
      removeRefreshToken();
      removeStorageToken();
    });
}
